// // const BASE = "http://localhost:5000";

// // export async function fetchFiles() {
// //   const res = await fetch(`${BASE}/list`);
// //   if (!res.ok) throw new Error("Failed to fetch list");
// //   return res.json();
// // }

// // export async function uploadFiles(fileList) {
// //   const form = new FormData();
// //   // fileList may be a FileList or array
// //   for (let i = 0; i < fileList.length; i++) {
// //     form.append("files", fileList[i]);
// //   }
// //   const res = await fetch(`${BASE}/upload`, { method: "POST", body: form });
// //   if (!res.ok) throw new Error("Upload failed");
// //   return res.json();
// // }

// // export async function analyzeEmail(filename) {
// //   const res = await fetch(`${BASE}/analyze/${encodeURIComponent(filename)}`);
// //   if (!res.ok) return res.json();
// //   return res.json();
// // }









// const BASE = "https://ai.tweakomatic.com";

// export async function fetchFiles() {
//   const res = await fetch(`${BASE}/list`);
//   return res.json();
// }

// export async function uploadFiles(fileList) {
//   const fd = new FormData();
//   for (let i = 0; i < fileList.length; i++) {
//     fd.append("files", fileList[i]);
//   }
//   const res = await fetch(`${BASE}/upload`, { method: "POST", body: fd });
//   return res.json();
// }

// export async function analyzeEmail(filename) {
//   const res = await fetch(`${BASE}/analyze/${filename}`);
//   return res.json();
// }

// export async function deleteFile(filename) {
//   const res = await fetch(`${BASE}/delete/${encodeURIComponent(filename)}`, {
//     method: 'DELETE',
//   });
//   if (!res.ok) {
//     const errorText = await res.text();
//     throw new Error(`Failed to delete file: ${res.status} - ${errorText || 'Server error'}`);
//   }
//   return res.json();
// }



const BASE = "https://ai.tweakomatic.com";

export async function fetchFiles() {
  const res = await fetch(`${BASE}/list`, {
    credentials: 'include'  // Added for session persistence
  });
  return res.json();
}

export async function uploadFiles(fileList) {
  const fd = new FormData();
  for (let i = 0; i < fileList.length; i++) {
    fd.append("files", fileList[i]);
  }
  const res = await fetch(`${BASE}/upload`, { 
    method: "POST", 
    body: fd,
    credentials: 'include'  // Added for session persistence
  });
  return res.json();
}

export async function analyzeEmail(filename) {
  const res = await fetch(`${BASE}/analyze/${filename}`, {
    credentials: 'include'  // Added for session persistence
  });
  return res.json();
}

export async function deleteFile(filename) {
  const res = await fetch(`${BASE}/delete/${encodeURIComponent(filename)}`, {
    method: 'DELETE',
    credentials: 'include'  // Added for session persistence
  });
  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Failed to delete file: ${res.status} - ${errorText || 'Server error'}`);
  }
  return res.json();
}